const Links = [
    {
        id: 1,
        text: "Esports SEO",
        url: "/esports-seo/"
    },
    {
        id: 2,
        text: "Blog",
        url: "/blog/"
    },
    {
        id: 3,
        text: "About Us",
        url: "/about-us/"
    },
    {
        id: 4,
        text: "Services",
        url: "/services/"
    },
    {
        id: 5,
        text: "Contact",
        url: "/contact/"
    },
]

export default Links